import React from 'react';

/**
 * Detail page for a single agent within the agency.
 */
export const Agent = () => {
  return (
    <div>
      <h2>Agent Details</h2>
    </div>
  );
};
